import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";

export const Nav = styled.nav`
	height: 75px;
	margin-top: -75px;
	box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};

	-webkit-box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};
	-moz-box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};
	display: flex;
	justify-content: center;
	align-items: center;
	position: sticky;
	top: 0;
	z-index: 10;
	background: ${({ changeColor }) => (changeColor ? "#f4f4f4" : "")};

	@media screen and (max-width: 960px) {
		transition: 0.8 all ease;
	} ;
`;

export const NavBarContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	height: 80px;
	z-index: 1;
	width: 100%;
	padding: 0 24px;
	max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
	justify-self: center;
	cursor: pointer;
	display: flex;
	align-items: center;
	position: absolute;
	left: 50%;
	transform: translate(-50%);
	color: red;
`;

export const NavLogoImg = styled.img`
	margin-top: 25px;
	border-radius: ${({ changeColor }) => (changeColor ? "100" : "")}px;
	background-color: ${({ changeColor }) => (changeColor ? "#f4f4f4" : "")};
	box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};

	-webkit-box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};
	-moz-box-shadow: ${({ changeColor }) =>
		changeColor ? "-1px 25px 17px -17px rgba(0, 0, 0, 0.21);" : "-0"};
	width: 100px; // jadi 250
	height: 100px;
`;

export const MobileIcon = styled.div`
	display: none;
	color: ${({ changeColor }) =>
		changeColor ? `var(--darkGrey)` : "var(--white)"};

	@media screen and (max-width: 720px) {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		transform: translate(-100%, 60%);
		cursor: pointer;
	}
`;
